// Shown atop a form/section that's been seeded from the network-defaults
// proposal, so the operator knows the values are derived (from the site's
// allocation + the standard vendor profile) and that editing + Save is what
// actually persists them.

export function GeneratedFromAllocationBanner({
  source,
}: {
  source?: { vendor_profile?: string; generator_version?: string };
}) {
  return (
    <div
      role="note"
      style={{
        display: "flex",
        gap: 8,
        alignItems: "baseline",
        padding: "8px 12px",
        background: "#0c2a3a",
        color: "#bae6fd",
        border: "1px solid #155e75",
        borderRadius: 6,
        fontSize: "0.82rem",
      }}
    >
      <strong>Prefilled from allocation</strong>
      <span style={{ opacity: 0.9 }}>
        Derived from this site's VLANs{source?.vendor_profile ? ` + the ${source.vendor_profile} profile` : ""}.
        These are editable defaults — review and <strong>Save</strong> to apply.
      </span>
    </div>
  );
}
